export enum LabelStyle {
  Unset = '',
  Default = 'Default',
  Flag = 'Flag'
}
